module.exports = __webpack_public_path__ + "static/img/er.1.4fa69918.png";